import React from 'react';

const ShareModal = ({
  shareLinks, shareMessage, setShareMessage,
  sharingLoading, createShareLink, copiedLink, setCopiedLink,
  copyToClipboard, revokeShareLink, onClose, t,
}) => (
  <div
    data-testid="share-modal"
    onClick={onClose}
    style={{
      position: 'fixed', inset: 0, zIndex: 60,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'fadeIn 0.3s ease-out',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        backgroundColor: '#0a0a0a',
        border: '1px solid rgba(212,175,55,0.25)',
        borderRadius: 16, padding: '36px 32px',
        maxWidth: 480, width: '90vw', maxHeight: '80vh', overflowY: 'auto',
        position: 'relative',
      }}
    >
      <button
        data-testid="close-share-modal"
        onClick={() => { onClose(); setCopiedLink(null); }}
        style={{
          position: 'absolute', top: 12, right: 12,
          background: 'none', border: 'none', cursor: 'pointer', padding: 8,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1,
        }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 20, color: '#D4AF37', textAlign: 'center', marginBottom: 8 }}>
        {t('share_title')}
      </h3>
      <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', textAlign: 'center', marginBottom: 24, fontStyle: 'italic' }}>
        {t('dash_share_desc')}
      </p>

      <div style={{ marginBottom: 24 }}>
        <textarea
          data-testid="share-message-input"
          value={shareMessage}
          onChange={e => setShareMessage(e.target.value)}
          placeholder="Message personnalis\u00e9 (optionnel)"
          rows={2}
          style={{
            width: '100%', backgroundColor: 'rgba(212,175,55,0.05)',
            border: '1px solid rgba(212,175,55,0.2)',
            borderRadius: 8, padding: '10px 14px',
            fontFamily: "'Georgia', serif", fontSize: 13,
            color: '#FAF3E0', resize: 'none',
          }}
        />
        <button
          data-testid="create-share-link-btn"
          onClick={createShareLink}
          disabled={sharingLoading}
          style={{
            fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: 600,
            backgroundColor: 'rgba(212,175,55,0.06)', color: '#000',
            border: 'none', padding: '12px 28px', borderRadius: 8,
            cursor: sharingLoading ? 'wait' : 'pointer',
            width: '100%', marginTop: 12,
            transition: 'all 0.3s',
            opacity: sharingLoading ? 0.6 : 1,
          }}
        >
          {sharingLoading ? 'Cr\u00e9ation...' : 'G\u00e9n\u00e9rer un lien de partage'}
        </button>
      </div>

      {copiedLink && (
        <div data-testid="share-link-copied" style={{
          backgroundColor: 'rgba(212,175,55,0.08)',
          border: '1px solid rgba(212,175,55,0.2)',
          borderRadius: 8, padding: '12px 16px', marginBottom: 20, textAlign: 'center',
        }}>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', marginBottom: 4 }}>
            Lien copi\u00e9 dans le presse-papiers
          </p>
          <p style={{ fontFamily: "monospace", fontSize: 11, color: '#FAF3E0', wordBreak: 'break-all' }}>
            {copiedLink}
          </p>
        </div>
      )}

      {shareLinks.length > 0 && (
        <div>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1 }}>
            Mes liens actifs
          </p>
          {shareLinks.filter(l => l.active).map(link => (
            <div key={link.id} data-testid={`share-link-${link.id}`} style={{
              backgroundColor: 'rgba(212,175,55,0.04)',
              border: '1px solid rgba(212,175,55,0.12)',
              borderRadius: 10, padding: '14px 16px', marginBottom: 10,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 10 }}>
                <div data-testid={`share-views-${link.id}`} style={{
                  minWidth: 52, textAlign: 'center',
                  backgroundColor: 'rgba(212,175,55,0.1)',
                  border: '1px solid rgba(212,175,55,0.25)',
                  borderRadius: 8, padding: '8px 6px',
                }}>
                  <span style={{ fontFamily: "'Georgia', serif", fontSize: 20, fontWeight: 600, color: '#D4AF37', display: 'block', lineHeight: 1 }}>
                    {link.views || 0}
                  </span>
                  <span style={{ fontFamily: "'Georgia', serif", fontSize: 9, color: '#D4AF37', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    {(link.views || 0) <= 1 ? 'visite' : 'visites'}
                  </span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {link.message && (
                    <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {link.message}
                    </p>
                  )}
                  <p style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: '#D4AF37', margin: '3px 0 0' }}>
                    {link.created_at ? new Date(link.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
                  </p>
                  <p style={{ fontFamily: "monospace", fontSize: 10, color: '#D4AF37', margin: '2px 0 0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {link.share_url}
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  data-testid={`copy-share-${link.id}`}
                  onClick={() => copyToClipboard(link.share_url)}
                  style={{
                    flex: 1, fontFamily: "'Georgia', serif", fontSize: 11,
                    color: '#D4AF37', backgroundColor: 'rgba(212,175,55,0.06)',
                    border: '1px solid rgba(212,175,55,0.2)',
                    padding: '6px 12px', borderRadius: 6, cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {t('share_copy')}
                </button>
                <button
                  data-testid={`revoke-share-${link.id}`}
                  onClick={() => revokeShareLink(link.id)}
                  style={{
                    fontFamily: "'Georgia', serif", fontSize: 11,
                    color: 'rgba(192,57,43,0.6)', backgroundColor: 'transparent',
                    border: '1px solid rgba(192,57,43,0.15)',
                    padding: '6px 12px', borderRadius: 6, cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {t('share_revoke')}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default ShareModal;
